
export enum LocationFromTypeEnum {
    FGWH = "FGWH",
    WH = "WH",
    INS = "INS",
    SUPP = "SUPP",
    PKMS = "PKMS"
}

export enum LocationToTypeEnum {
    FGWH = "FGWH",
    WH = "WH",
    INS = "INS",
    SUPP = "SUPP",
    SHIP = "SHIP"
}


export enum ReqStatus {
    OPEN = 0,
    DONE = 1
}